import { render } from "./Objects.vue?vue&type=template&id=b24d7afc&scoped=true"
import script from "./Objects.vue?vue&type=script&lang=js"
export * from "./Objects.vue?vue&type=script&lang=js"

import "./Objects.vue?vue&type=style&index=0&id=b24d7afc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24d7afc"]])

export default __exports__